import { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import InputSearch from "./InputSearch";

const SearchFilter = ({ label, onchange, className, placeholder }) => {
  const { t } = useTranslation();
  const [searchKeyword, setSearchKeyword] = useState("");
  const onchangeRef = useRef(onchange);

  useEffect(() => {
    onchangeRef.current = onchange;
  }, [onchange]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (onchangeRef.current) {
        onchangeRef.current({ value: searchKeyword });
      }
    }, 500);

    return () => clearTimeout(timer);
  }, [searchKeyword]);

  const handleChange = (e) => {
    setSearchKeyword(e.target.value);
  };

  return (
    <div className={`card-style select-filter ${className}`}>
      <p className="font_14 font-bold font-color-grey mb-0">{label}</p>
      <div>
        <InputSearch
          placeHolder={placeholder || ""}
          value={searchKeyword}
          onChange={handleChange}
        />
      </div>
    </div>
  );
};

SearchFilter.propTypes = {
  label: PropTypes.string,
  onchange: PropTypes.func,
  className: PropTypes.string,
  placeholder: PropTypes.string,
};

SearchFilter.defaultProps = {
  label: "",
  className: "",
  onchange: () => {},
  placeholder: "",
};

export default SearchFilter;
